/* eslint-disable camelcase */
import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export async function GetEmailDL(salesOrg: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/admin/email/dl`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export interface salesOffice{
  city: string;
  code: string;
  sales_org: string;
  state: string;
  text: string;
  text_long: string;
}
export async function getSalesOffices(salesOrg: string,is_all?:any): Promise<salesOffice[]> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      is_all:is_all
    },
    url: `${BASE_URL}/api/admin/deliveryPlants`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export interface DupECA{
  client_id:number;
  sales_org:string;
  sales_office:string;
  customer_num:string;
  CNT:number;
  equipment_num:string;
  active_equipment_nums:{
    equipment_num:string,
    valid_from_dt:string
  }[];
}
export async function getDuplicateECA(salesOrg: string): Promise<DupECA[]> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/internalsupport/detect/DuplicateECA`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data.dupECA)
    .catch((err) => console.error(err));
}


export type LastSentPDF = {
  clientId: number;
  salesOrg: string;
  lastPdfEmailDt: Date;
  pendingCount: number;
	pdfGrouping: string;
}
export type rspHCEmailPDF ={
  message:string;
  lastSent:LastSentPDF[];
  pending:any[];
}
/**
 * gets Email Healthcheck
 * @param salesOrg 
 * @returns 
 */
export async function getHCEmailPDF(salesOrg: string): Promise<rspHCEmailPDF> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/internalsupport/HC/EmailPDF`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export type respHCTicketStatus = {
  message: string; 
  ticketStatus:{
    clientId: number;
    salesOrg: string;
    requestNum: number;
    customerNum: string;
    equipmentNum: string;
    sapRequestNum: string;
    requestStatus: string;
    optimizationType: string;
    executionDt: Date;
    lastChangeDt: Date;
    closeDateDt: Date;
    pdfEmailDt: Date;
    changeTrackDt: Date;
    ticketNum: string;
    ticketMode: string;
    ticketStatus: string;
    visitDt: Date;
    requestedDt: Date;
  }[];
}
/**
 * gets Email Healthcheck
 * @param salesOrg 
 * @returns 
 */
 export async function getHCTicketStatus(salesOrg: string): Promise<respHCTicketStatus> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/internalsupport/HC/TicketStatus`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export interface AllECA{
  client_id:number;
  sales_org:string;
  sales_office:string;
  master_route:string;
  city:string;
  customer_num:string;
  name1:string;
  name3:string;
  equipment_num:string;
  valid_from_dt:string;
  valid_to_dt:string;
  asset_num:string;
  manufacturer:string;
  model:string;
  building:string;
  floor:string;
  room:string;
  status:string;
}
export async function getAllECA(salesOrg: string, salesOffice: string): Promise<{allECA:AllECA[],message:string}> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      salesOffice: salesOffice,
    },
    url: `${BASE_URL}/api/internalsupport/detect/AllActiveSalesOfficeECA`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}


export type PriorityQueueSum = {
  bucket_dt: string;
  queue_name: string;
  insert_rc: number;
  start_rc: number;
  end_rc: number;
  open_rc: number;
  oldest_open: Date;
  newest_open: Date;
  batch_count: number;
  record_count: number;
  total_ms: number;
  total_run_time: Date;
  max_ms_run: number;
  min_ms_run: number;
  avg_ms_run: number;
  max_ms_run_per: number;
  min_ms_run_per: number;
  avg_ms_run_per: number;
};
export type respPriorityQueueSum = { 
  message: string;
  priorityQueueSum:PriorityQueueSum[] 
}
export async function getPriorityQueueSum(
  salesOrg: string, 
  startDt:string, 
  endDt:string 
): Promise<respPriorityQueueSum> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      startDt,
      endDt
    },
    url: `${BASE_URL}/api/internalsupport/PrioQueue/Monitor`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => {console.error(err); return err.response.data});
}
type DexCollisionID = {
  device_id_key: string;
  collision_count: number;
  sub_serial_num: string;
  equipment_num: string;
  customer_num: string | undefined | null;
  sales_org: string;
  delivering_plant: string | undefined | null;
  eqp_active: number;
  eqp_invalid: number;
  eqp_status: string;
  cust_active: number | undefined | null;
  customererrors: number | undefined | null;
  materialerrors: number | undefined | null;
  central_order_block: string | undefined | null;
  central_delivery_block: string | undefined | null;
  supp_reason: string | undefined | null;
  central_sales_block: string | undefined | null;
  central_deletion_block: string | undefined | null;
};
export type respDEXCollisionIDs = { 
  message: string;
  dexCollisionIDs:DexCollisionID[] 
}
export async function getDEXCollisionIDs(clientId: string, salesOrg: string): Promise<respDEXCollisionIDs> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId,
      salesOrg,
    },
    url: `${BASE_URL}/api/internalsupport/DEX/CollisionIDs`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => {console.error(err); return err.response.data});

}

type HighCallDEX = {
  sales_org: string;
  delivering_plant: string;
  customer_num: string;
  equipment_num: string;
  sub_serial_num: string;
  sub_manu_serial_num: string;
  last_transmission_dt: Date;
  total: number;
  deviceid: string;
  da101: string;
  transmit_1: Date;
  diff_1_2: string;
  diff_1_2_sec: number;
  transmit_2: Date;
  diff_2_3: string;
  diff_2_3_sec: number;
  transmit_3: Date;
  diff_3_4: string;
  diff_3_4_sec: number;
  transmit_4: Date;
  diff_4_5: string;
  diff_4_5_sec: number;
  transmit_5: Date;
  diff_5_6: string;
  diff_5_6_sec: number;
  transmit_6: Date;
  diff_6_7: string;
  diff_6_7_sec: number;
  transmit_7: Date;
};
export type respDEXHighCall = { 
  message: string;
  dexHC:HighCallDEX[] 
}

export async function getDEXHighCall(clientId: string, salesOrg: string): Promise<respDEXHighCall> {
  const daysBack = 7 // hardcoded for now, can be paramaterized if needed. 7 max
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId,
      salesOrg,
      daysBack,
    },
    url: `${BASE_URL}/api/internalsupport/DEX/HighCall`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => {console.error(err); return err.response.data});

}


type DexProviderCallsPerDay = {
  providerid: string;
  applicationid: string;
  dex_date: string;
  unique: number;
  calls: number;
};
export type respDEXPCPD = { 
  message: string;
  dexCPD:DexProviderCallsPerDay[] 
}

export async function getDexProviderCallsPerDay(clientId: string, salesOrg: string): Promise<respDEXPCPD> {
  const daysBack = 14 // hardcoded for now, can be paramaterized if needed. 
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId,
      salesOrg,
      daysBack,
    },
    url: `${BASE_URL}/api/internalsupport/DEX/ProviderCallsPerDay`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => {console.error(err); return err.response.data});

}

export type vdi_json = {
  providerid: string;
  applicationid: string;
  deviceid: string;
  da101: string;
  transactionid: string;
  readdatetime: string;
  transmittime: string;
  transactiontime: string;
  filesize: number;
  dexreason: string;
  status: string;
};

type NoCallDEX = {
  client_id: number;
  sales_org: string;
  delivering_plant: string;
  master_route: string;
  customer_num: string;
  customererrors: number;
  materialerrors: number;
  equipment_num: string;
  invalid: number;
  dex_device_id: string;
  model: string;
  status: string;
  sub_serial_num: string;
  sub_manu_serial_num: string;
  manufacturer: string;
  sub_eqp_used_elsewhere: string;
  last_visit_dt: string;
  last_tx_dex_dt: string;
  last_tx_dex_source: string;
  dt_device_id: string;
  dt_da101: string;
  dt_device_id_key: string;
  deviceid: string;
  da101: string;
  device_id_key: string;
  min_dt: string;
  max_dt: string;
  total: number;
  dupe_sub_eqp: string;
  failed_to_update: string;
  no_call_in: string;
  device_id_missmatch: string;
  pending_data: string;
  vdi_json: string|vdi_json[];
};

export type respDEXNoCall = { 
  message: string;
  dexNC:NoCallDEX[] 
}

export async function getDEXNoCall(clientId: string, salesOrg: string): Promise<respDEXNoCall> {
  const daysBack = 14 // hardcoded for now, can be paramaterized if needed. 7 max
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId,
      salesOrg,
      daysBack,
    },
    url: `${BASE_URL}/api/internalsupport/DEX/NoCall`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => {console.error(err); return err.response.data});

}

export async function GetMaterialReplacement(salesOrg: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/admin/material/replace`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function GetMaterialStrategic(salesOrg: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/admin/material/strategic`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function GetMaterialList(salesOrg: string,deliveryPlant: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      deliveryPlant: deliveryPlant,
    },
    url: `${BASE_URL}/api/materiallist`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getStates(salesOrg:string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/admin/map/state`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}
export async function GetCounty(stateFips: string,salesOrg: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      stateFips: stateFips,
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/admin/map/county`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function GetMap(salesOrg: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/admin/map`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function GetOptimizationParameters(salesOrg: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/admin/optimization/parameters`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}


export async function GetSyConfiguration(salesOrg: string, app:{vp?:boolean,vs?:boolean}): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      vs: (app.vs)?1:0,
      vp: (app.vp)?1:0,
    },
    url: `${BASE_URL}/api/admin/configuration`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function GetSyPlanConfiguration(salesOrg: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/admin/planmodeconfig`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}


export async function GetEquipmentMapping(salesOrg: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/admin/equipment/mapping`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function GetCategoryList(salesOrg: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      lang:'EN',
      contexts:'BEVERAGECATEGORY'
    },
    url: `${BASE_URL}/api/admin/beveragecategory/listing`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export interface MissingVMConfig{
  model:string;
  packType:string;
  packSize:string;
  typeFound:'ml'|'cm'|'ob';
  salesOrgs?:string[];
}
export interface MissingVMConfigs{
  hadError:boolean;
  ml:MissingVMConfig[];
  cm:MissingVMConfig[];
  ob:MissingVMConfig[];
  texts:{code:string,text:string}[];
}
export async function GetEquipmentMissingConfig(salesOrg: string): Promise<MissingVMConfigs> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/admin/equipment/detect_missing_config`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function GetSalesOfficeOperation(salesOrg: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/admin/salesoffice/operation`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function GetEquipmentCapacity(salesOrg: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/admin/equipment/capacity`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}


export async function downloadMaterialSortCSV(salesOrg: string): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  const config: AxiosRequestConfig = {
    method: "GET",
    params: params,
    url: `${BASE_URL}/api/admin/csv/material/sort/`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.error(err));
}

export async function downloadBankCSV(salesOrg: string, salesOffice: string): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  if(salesOffice !== '*'){
    params.salesOffice = salesOffice
  }
  const config: AxiosRequestConfig = {
    method: "GET",
    params: params,
    url: `${BASE_URL}/api/admin/csv/banks/`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.error(err));
}


export async function downloadNoteCSV(salesOrg: string): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  const config: AxiosRequestConfig = {
    method: "GET",
    params: params,
    url: `${BASE_URL}/api/admin/csv/notes/`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.error(err));
}

export async function downloadMaterialCSV(salesOrg: string): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  const config: AxiosRequestConfig = {
    method: "GET",
    params: params,
    url: `${BASE_URL}/api/admin/csv/ValidateImage/`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.error(err));
}

export async function downloadSuspensionCSV(salesOrg: string): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  const config: AxiosRequestConfig = {
    method: "GET",
    params: params,
    url: `${BASE_URL}/api/admin/csv/suspension/`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.error(err));
}

export async function downloadSalesCSV(salesOrg: string): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  const config: AxiosRequestConfig = {
    method: "GET",
    params: params,
    url: `${BASE_URL}/api/admin/csv/salesdays/`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.error(err));
}

export async function downloadCustomersExcel(clientId: string, salesOrg: string): Promise<any> {
  const config: AxiosRequestConfig = {
   method: "GET",
   params: {
      clientId,
      salesOrg,
    },
    url: `${BASE_URL}/api/admin/export/dexcustomers`,
  };
  return await AXIOS_INSTANCE(config)
}

export async function GetBatchStatus(salesOrg: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/admin/batch/status`,
  };

  return await AXIOS_INSTANCE(config)
}

export async function GetBatchHistory(salesOrg: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/admin/batch/history`,
  };

  return await AXIOS_INSTANCE(config)
}

export async function getAccessConfigs(salesOrg: string,email:string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      email
    },
    url: `${BASE_URL}/api/admin/accessconfig`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getAllAccessConfigs(salesOrg: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/admin/accessconfig/all`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function saveAccessConfig(
  salesOrg: string,
  email:string,
  deliveryPlant: string,
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      email,
      deliveryPlant,
    },
    url: `${BASE_URL}/api/admin/accessconfig/save`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function deleteAccessConfig(salesOrg:string,guid:string) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg
    },
    data: {
      guid
    },
    url: `${BASE_URL}/api/admin/accessconfig/delete`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

//#region Contract GET

export async function getAllContracts(salesOrg: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/admin/contracts/all`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function saveContract(
  salesOrg: string,
  contract: any
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: contract,
    url: `${BASE_URL}/api/admin/contracts/save`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function deleteContract(
  salesOrg: string,
  contractId: number
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      contract_id: contractId,
    },
    url: `${BASE_URL}/api/admin/contracts/delete`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getContractCustomers(
  salesOrg: string,
  contractId?: number
) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      contractId,
    },
    url: `${BASE_URL}/api/admin/contracts/customers`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getAssignedContractCustomers(
  salesOrg: string,
  contractId: number
) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      contractId,
    },
    url: `${BASE_URL}/api/admin/contracts/customers/assigned`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function saveContractCustomers(
  salesOrg: string,
  contractId: number,
  customerNums: string[]
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      contract_id: contractId,
      customer_nums: customerNums,
    },
    url: `${BASE_URL}/api/admin/contracts/customers/save`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function bulkUploadContracts(
  salesOrg: string,
  contracts: any[]
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      contracts,
    },
    url: `${BASE_URL}/api/admin/contracts/bulkupload`,
  };

  const response = await AXIOS_INSTANCE(config);
  return response.data;
}

//#endregion

export async function getInconsistentReportData(salesOrg: string,plant:string,type:string): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg,
    plant,
    type:type
  }
  const config: AxiosRequestConfig = {
    method: "GET",
    params: params,
    url: `${BASE_URL}/api/admin/sap/inconsistent/data`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.error(err));
}

export async function getInconsistentGenerate(salesOrg: string): Promise<any> {
  let params:{[key:string]:string} = {
    clientId: "100",
    salesOrg: salesOrg
  }
  const config: AxiosRequestConfig = {
    method: "GET",
    params: params,
    url: `${BASE_URL}/api/admin/sap/inconsistent/generate`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v)
    .catch((err) => console.error(err));
}

export async function GetRouteConfiguration(salesOrg: string,param_name:string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      param_name:param_name
    },
    url: `${BASE_URL}/api/admin/routeresetconfig`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}


export async function GetSysConfigMaintenance(salesOrg: string, app:{vp?:boolean,vs?:boolean}): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      param_name:"maintenance_mode",
      vs: (app.vs)?1:0,
      vp: (app.vp)?1:0,
    },
    url: `${BASE_URL}/api/sysconfig/getMaintenanceMode`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function getTradeChannels(salesOrg: string):  Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,

    },
    url: `${BASE_URL}/api/admin/gettradechannels`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
  }


  export async function getSubTradeChannels(salesOrg: string,trade_channel:string):  Promise<any> {
    const config: AxiosRequestConfig = {
      method: "GET",
      params: {
        clientId: "100",
        salesOrg: salesOrg,
        trade_channel: trade_channel,
      },
      url: `${BASE_URL}/api/admin/getsubtradechannels`,
    };
  
    return await AXIOS_INSTANCE(config)
      .then((v) => v.data)
      .catch((err) => console.error(err));
    }

    export async function GetTradeConfiguration(salesOrg: string): Promise<any> {
      const config: AxiosRequestConfig = {
        method: "GET",
        params: {
          clientId: "100",
          salesOrg: salesOrg,
        },
        url: `${BASE_URL}/api/admin/tradesubtradeconfig/listing`,
      };
    
      return await AXIOS_INSTANCE(config)
        .then((v) => v.data)
        .catch((err) => console.error(err));
    }

    export async function GetBottleCanConfiguration(salesOrg: string): Promise<any> {
      const config: AxiosRequestConfig = {
        method: "GET",
        params: {
          clientId: "100",
          salesOrg: salesOrg,
        },
        url: `${BASE_URL}/api/admin/bottlecanconfig/listing`,
      };
    
      return await AXIOS_INSTANCE(config)
        .then((v) => v.data)
        .catch((err) => console.error(err));
    }

    export async function GetPackSizes(salesOrg: string,material_num?:string,bpp?:string): Promise<any> {
      const config: AxiosRequestConfig = {
        method: "POST",
        params: {
          clientId: "100",
          salesOrg,
        },
        data: {
          lang:'EN',
          contexts:'PACKSIZE',
          materialNum:material_num,
          bpp:bpp,
        },
        url: `${BASE_URL}/api/admin/bottlecan/getPackSize`,
      };
    
      return await AXIOS_INSTANCE(config)
        .then((v) => v.data)
        .catch((err) => console.error(err));
    }

    export async function GetPackTypes(salesOrg: string,material_num?:string,bpp?:string): Promise<any> {
      const config: AxiosRequestConfig = {
        method: "POST",
        params: {
          clientId: "100",
          salesOrg,
        },
        data: {
          lang:'EN',
          contexts:'PACKTYPE',
          materialNum:material_num,
          bpp:bpp,
        },
        url: `${BASE_URL}/api/admin/bottlecan/getPackType`,
      };
    
      return await AXIOS_INSTANCE(config)
        .then((v) => v.data)
        .catch((err) => console.error(err));
    }

    export async function GetBeverageProduct(salesOrg: string,material_num?:string): Promise<any> {
      const config: AxiosRequestConfig = {
        method: "POST",
        params: {
          clientId: "100",
          salesOrg,
        },
        data: {
          lang:'EN',
          contexts:'BEVERAGEPRODUCT',
          materialNum:material_num
        },
        url: `${BASE_URL}/api/admin/bottlecan/getBeverageProduct`,
      };
    
      return await AXIOS_INSTANCE(config)
        .then((v) => v.data)
        .catch((err) => console.error(err));
    }


    export async function GetMaterialListByPlant(salesOrg: string,deliveryPlant: string): Promise<any> {
      const config: AxiosRequestConfig = {
        method: "GET",
        params: {
          clientId: "100",
          salesOrg: salesOrg,
          deliveryPlant: deliveryPlant,
        },
        url: `${BASE_URL}/api/admin/materiallist`,
      };
    
      return await AXIOS_INSTANCE(config)
        .then((v) => v.data)
        .catch((err) => console.error(err));
    }

    export async function GetActiveMaterialData(salesOrg: string): Promise<any> {
      const config: AxiosRequestConfig = {
          method: "GET",
          params: {
            clientId: "100",
            salesOrg: salesOrg,
          },
          url: `${BASE_URL}/api/activemateriallist`,
      };
      return await AXIOS_INSTANCE(config)
      .then((v) => v.data)
      .catch((err) => console.error(err));
  }

  export async function deleteVSImageFromBlob(image: string,salesOrg: string): Promise<any> {
    const config: AxiosRequestConfig = {
      method: "POST",
      params: {
        clientId: "100",
        salesOrg: salesOrg,
        image: image,
      },
      url: `${BASE_URL}/api/admin/deleteVpImage`,
    };
  
    return await AXIOS_INSTANCE(config)
      .then((v) => v.data)
      .catch((err) => console.error(err));
  }

  export async function GetActiveMaterialList(salesOrg: string): Promise<any> {
      const config: AxiosRequestConfig = {
          method: "GET",
          params: {
            clientId: "100",
            salesOrg: salesOrg,
          },
          url: `${BASE_URL}/api/admin/activemateriallistdata`,
      };
      return await AXIOS_INSTANCE(config)
      .then((v) => v.data)
      .catch((err) => console.error(err));
  }
  export async function makeHttpTrigger(salesOrg: string): Promise<any> {
          let params:{[key:string]:string} = {
              clientId: "100",
              salesOrg: salesOrg,
          }
      const recoConf: AxiosRequestConfig = {
    method: "GET",
    params,
    url: `${BASE_URL}/api/admin/triggerImageRepo`,
  };

  const rec = await AXIOS_INSTANCE(recoConf)
    .then((v) => v.data)
    .catch((err) => console.error(err));

  return { ...rec };
}

export async function getDEXReport(salesOrg: string): Promise<any> {
const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId:"100",
      salesOrg,
    },
    url: `${BASE_URL}/api/internalsupport/SendEmails/Report/DailyDex`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => {console.error(err); return err.response.data});

}

export async function getLatestLoginsForSalesOrg(salesOrg: string, salesOrgName: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      lang: "EN",
      clientId: "100",
      salesOrg: salesOrg,
      salesOrgName: salesOrgName,
    },
    url: `${BASE_URL}/api/admin/logins/latest`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}